import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Box, Divider, IconButton, Paper, Stack, Typography } from '@mui/material';

import { AddButtonUi, FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const createNewRow = () => ({
  id: `new_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
  value: '',
  externalCode: '',
  isNew: true,
});

const ItemTypePropertyValuesGrid = ({ disabled, rows, setRows, submitAttempted }) => {
  const hasRows = rows.length > 0;

  const handleRowChange = (id, field, fieldValue) => {
    setRows((prev) => prev.map((item) => (item.id === id ? { ...item, [field]: fieldValue } : item)));
  };

  const handleAdd = () => {
    setRows((prev) => [createNewRow(), ...prev]);
  };

  const handleDelete = (id) => {
    setRows((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box sx={{ px: 2, pb: 3 }}>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Stack spacing={2}>
          <Box>
            <Typography variant="subtitle1" fontWeight={700}>
              Választólista elemei
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Itt lehet felvenni és szerkeszteni a választható elemeket.
            </Typography>
          </Box>

          <Box>
            <AddButtonUi disabled={disabled} onClick={handleAdd} />
          </Box>

          <Divider />

          {!hasRows && (
            <Typography variant="body2" color="text.secondary">
              Még nincs felvett érték.
            </Typography>
          )}

          <Stack spacing={1.5}>
            {rows.map((item) => {
              return (
                <Paper
                  key={item.id}
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: '#fafcfe',
                  }}
                >
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: { xs: '1fr', md: '1.2fr 1fr auto auto' },
                      gap: 2,
                      alignItems: 'start',
                    }}
                  >
                    <InputUI
                      value={item.value}
                      label={<FormLabelUI text="Érték" />}
                      variant="outlined"
                      size="small"
                      disabled={disabled}
                      onChange={(e) => {
                        handleRowChange(item.id, 'value', e.target.value);
                      }}
                      helperText={<FormErrorUI message={submitAttempted && !item.value?.trim() ? 'Kötelező' : ''} />}
                    />
                    <InputUI
                      value={item.externalCode}
                      label={<FormLabelUI text="Külső azonosító" />}
                      variant="outlined"
                      size="small"
                      disabled={disabled}
                      onChange={(e) => {
                        handleRowChange(item.id, 'externalCode', e.target.value);
                      }}
                    />
                    <Box />
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: { xs: 'flex-start', md: 'flex-end' },
                        alignItems: 'center',
                        minHeight: 40,
                      }}
                    >
                      <IconButton size="small" disabled={disabled} color="error" onClick={() => handleDelete(item.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Paper>
              );
            })}
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ItemTypePropertyValuesGrid;
